import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Badge } from "@/components/common";
import { Bell, Check } from "lucide-react";

const KIND_TONE = { invite: "blue", proposal: "green", stage: "purple", sanction: "red", delivery: "purple", rep_action: "purple", verification: "amber", info: "muted" };

export default function Notifications() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markRead = async () => { await api.post("/notifications/read"); load(); };

  return (
    <div className="max-w-3xl space-y-4" data-testid="notifications-page">
      <div className="flex items-center justify-between border-b-2 border-foreground pb-3">
        <div><p className="overline mb-1 flex items-center gap-1"><Bell size={13} /> {t("Inbox")}</p><h1 className="font-display text-3xl font-extrabold tracking-tight">{t("Notifications")}</h1></div>
        <button onClick={markRead} data-testid="mark-read-btn" className="flex items-center gap-1.5 text-sm border border-border px-3 py-1.5 rounded-sm hover:bg-muted transition-colors"><Check size={15} /> {t("Mark all read")}</button>
      </div>
      <div className="space-y-2">
        {items.map((n) => {
          const inner = (
            <div className={`border p-4 rounded-sm flex items-start gap-3 ${n.read ? "border-border bg-white" : "border-primary/40 bg-primary/5"}`} data-testid="notification-item">
              <Badge tone={KIND_TONE[n.kind] || "muted"}>{n.kind}</Badge>
              <div className="flex-1"><p className="text-sm text-foreground">{n.text}</p><p className="text-xs text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString()}</p></div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-primary mt-1" />}
            </div>
          );
          return n.debate_id ? <Link key={n.id} to={`/debates/${n.debate_id}`}>{inner}</Link> : <div key={n.id}>{inner}</div>;
        })}
        {items.length === 0 && <p className="text-sm text-muted-foreground">{t("No notifications yet.")}</p>}
      </div>
    </div>
  );
}
